import http from 'services/httpService';
import { IProjectsResponse } from 'types/api-responses';
import { IApiRoutes } from 'types/api-routes';

export const getProjectsData = (): Promise<IProjectsResponse> => {
  const currentYear = new Date().getFullYear();
  const filters = [
    { id: 'allProjects', name: 'All', default: true },
    { id: '6', name: `${currentYear}`, default: false },
    { id: '5', name: `${currentYear - 1}`, default: false },
    { id: '4', name: `${currentYear - 2}`, default: false },
    { id: '3', name: `${currentYear - 3}`, default: false },
    { id: '2', name: `${currentYear - 4}`, default: false },
    { id: '1', name: `${currentYear - 5}`, default: false },
  ];

  return Promise.resolve(
    http.get(`${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Projects}`)
  )
    .then((response) => {
      return {
        data: {
          projects: response.data,
          filters,
        },
      };
    })
    .catch((err) => err);
};
